module.exports = __webpack_public_path__ + "03_very_short_yellow.a4e794c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_very_short_yellow.png
// module id = qLGB
// module chunks = 0